// Constant for default/initial values
export const DEFAULT_POOL_ADDRESS = '0x88e6A0c2dDD26FEEb64F039a2c41296FcB3f5640'

let names: PoolNames = {
    [DEFAULT_POOL_ADDRESS]: "USDC-WETH-5bps",
    "0x3416cF6C708Da44DB2624D63ea0AAef7113527C6": "USDC-USDT-1bps",
    "0x11b815efB8f581194ae79006d24E0d814B7697F6": "WETH-USDT-5bps",
    "0x4585FE77225b41b697C938B018E2Ac67Ac5a20c0": "WBTC-WETH-5bps",
    "0x8ad599c3A0ff1De082011EFDDc58f1908eb6e6D8": "USDC-WETH-30bps",
    "0xc7bBeC68d12a0d1830360F8Ec58fA599bA1b0e9b": "WETH-USDT-1bps",
    "0xCBCdF9626bC03E24f779434178A73a0B4bad62eD": "WBTC-WETH-30bps",
    "0x5777d92f208679DB4b9778590Fa3CAB3aC9e2168": "DAI-USDC-1bps",
    "0x4e68Ccd3E89f51C3074ca5072bbAC773960dFa36": "WETH-USDT-30bps",
    "0x60594a405d53811d3BC4766596EFD80fd545A270": "DAI-WETH-5bps",
    "0x7858E59e0C01EA06Df3aF3D20aC7B0003275D4Bf": "USDC-USDT-5bps",
    "0x435664008F38B0650fBC1C9fc971D0A3Bc2f1e47": "USDe-USDT-1bps",
    "0xa6Cc3C2531FdaA6Ae1A3CA84c2855806728693e8": "LINK-WETH-30bps",
    "0x11950d141EcB863F01007AdD7D1A342041227b58": "PEPE-WETH-30bps",
    "0x9a772018FbD77fcD2d25657e5C547BAfF3Fd7D16": "WBTC-USDC-5bps",
    "0x99ac8cA7087fA4A2A1FB6357269965A2014ABc35": "WBTC-USDC-30bps",
    "0x1d42064Fc4Beb5F8aAF85F4617AE8b3b5B8Bd801": "UNI-WETH-30bps",
    "0xC2e9F25Be6257c210d7Adf0D4Cd6E3E881ba25f8": "DAI-WETH-30bps",
    "0x48DA0965ab2d2cbf1C17C09cFB5Cbe67Ad5B1406": "DAI-USDT-1bps",
    "0x0d4a11d5EEaaC28EC3F61d100daF4d40471f1852": "USDT-WETH-v2",
    "0xB4e16d0168e52d35CaCD2c6185b44281Ec28C9Dc": "WETH-USDC-v2",
    "0xa43fe16908251ee70ef74718545e4fe6c5ccec9f": "PEPE-WETH-v2"
};

export type PoolNames = {
    [key: string]: string;
};
  

export default names;